import type { ConversationVisibility, FeedbackRating, ResponseMode } from "../../shared/api/types";

export const responseModeOptions: Array<{ value: ResponseMode; label: string; description: string }> = [
  { value: "analysis", label: "Анализ", description: "Пояснения и варианты для специалиста ТС" },
  { value: "draft", label: "Шаблон", description: "Готовый черновик ответа клиенту" },
  { value: "both", label: "Оба", description: "Анализ и отдельный черновик ответа" },
];

export const visibilityOptions: Array<{ value: ConversationVisibility; label: string }> = [
  { value: "personal", label: "Личная" },
  { value: "shared", label: "Выбранные сотрудники" },
  { value: "department", label: "Подразделение" },
  { value: "tech_service", label: "Техническая служба" },
];

export const feedbackOptions: Array<{ value: FeedbackRating; label: string }> = [
  { value: "useful", label: "Полезно" },
  { value: "partial", label: "Частично" },
  { value: "not_useful", label: "Не помогло" },
];

export const feedbackReasons = [
  "Не найдена нужная карточка",
  "Использована неверная карточка",
  "Ошибка в базе знаний",
  "Неверно понят вопрос",
  "Не хватает сведений",
  "Неудачная формулировка",
  "Другое",
];
